import * as React from 'react';
import Layout from '../../components/Layout/Layout'

import Grid from '@mui/material/Grid';
import { Button, Toolbar, Typography } from '@mui/material';
import { Link, NavLink } from 'react-router-dom';
import Typewriter from 'typewriter-effect';  
import Portfolio from '../../images/portfolio.png'; 
import './Home.css'
import Education from '../Education/Education';
import Skills from '../Skills/Skills'; 
import Contact from '../Contact/Contact';
import Lottie from 'lottie-react';
import HandAnimation from '../../lottiefiles/writing.json'
import Project from '../Project/Project'; 
// import { SocialMedia } from '../../components/Comp/AllComponents'; 
import SocialButtons from '../../components/SocialButtons/SocialButtons';
import Resume from '../../images/Abhishek Maurya.pdf';

const Home = () => {

  // const resumePath = '../../images/Abhishek M+aurya.pdf';
  const fileName = 'Abhishek Maurya.pdf';


  return (
    <>

      <Layout >
        {/* toolbar use for line space  */}
        {/* <Toolbar /> */}

        <div className=" homePage container " >
      

            <Grid  className='main_grid' container columns={16}>
              <Grid className='grid_left' xs={14} sm={7.4}>
                <div className="flexHome">
                  <Typography
                    variant='div'
                    sx={{width:'100%', display:'flex'}}
                  >   
                   <Lottie className='h3_span' animationData={HandAnimation} loop={true}/>
                  </Typography>
                  
                  <Typography
                    variant='h3'
                    sx={{width:'100%'}}
                  > 
                   Hi I'm Abhishek
                  </Typography>

                  <Typography
                    className='homeContent'
                    variant='h5'
                    sx={{ mt: 3 }}
                  >
                     <span  className="homeAnimation" style={{ fontWeight: 'bold' }}>
                    <Typewriter
                   
                      options={{
                        strings: ['MERN Stack Developer', 'Frontend Developer'],
                        autoStart: true,
                        loop: true,
                      }}
                    />
                    </span>
                 
                  </Typography>

                  <p
                    className='homePara'
                  >
                    Good experience in web design and development knowledge, producing quality work.
                  </p>
                  <p className="homePara">
                  HTML || CSS || JAVASCRIPT || REACT || Bootstrap5 || MaterialUI || MongoDB || Web 3 Enthusiast
                  </p>
                </div>
                <Typography
                  variant='div'
                  component={'div'}
                  className='buttons'
                  sx={{ marginLeft: 2, mt: 2, mb:6 }}
                >
                  <Button
                  size='small'
                    variant='contained'                
                    className='home_btn btn'
                    sx={{              
                      fontSize: 18, mt: 4 }}
                  >
                    
                    <Link  
                    to={Resume}
                    download={fileName}
                    target='_blank'
                    >Download My Resume</Link>
                  </Button>

                  <Button
                  size='small'
                    variant='outlined'                
                    className='home_btn2 btn'
                    sx={{              
                      fontSize: 18, mt: 4 }}
                  >
                    <NavLink  
                    to='/skills'
                    
                    >My Work's</NavLink>
                  </Button>

                  {/* <Button
                  size='small'
                    variant='outlined'
                    sx={{ fontSize: 18, ml: 10, mt:4 }}
                    className='home_btn-2 btn'
                  >
                    <NavLink>My Work's</NavLink>
                  </Button> */}
                </Typography>

                {/* Social Media icons */}
<SocialButtons />

                {/* <SocialMedia />                  */}
                

              </Grid>
              <Grid className='grid_right' xs={14} sm={8}>
                <div className='right_div'>
                  <img src={Portfolio} alt="portfolio" />
                  {/* add animation */}
                </div>
              </Grid>
            </Grid>

    <Education />
    <Skills />
    <Project /> 
    <Contact />



          </div>

 

        <Toolbar />
      </Layout>

    </>
  )
}

export default Home
